import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ProfileService } from '../../profile.service';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../api.service';
import { DialogOverviewConfirmationComponent } from '../../dialog-overview-confirmation/dialog-overview-confirmation.component';

@Component({
  selector: 'lib-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent implements OnInit, OnChanges {
  dataToPass: any;
  isRead : any;
  otpView:boolean = false;
  interval;
  submitShow:boolean=true;
  showResend:boolean=false;
  @Input() userprinciplename;
  @Input() passAppList;
  @Input() logOutUrl;
  subscripeAppList:any;
  timeLeft: number = 90;
  submitted:boolean=false;
  userInfo;
  @Output() dataEvent = new EventEmitter();
  hideAll:boolean=true;
  showButton:boolean=false;
  accountDeleted: boolean = false;
  @ViewChild('otpModel') otpModel;
  otpval:any;
  constructor(
    private userService: ProfileService,
    private dialogBox: MatDialog,
    private apiService: ApiService) { }

  ngOnInit() {
  }
  ngOnChanges(){
    if(this.passAppList){
      this.userInfo = this.passAppList;
      this.subscripeAppList = this.passAppList.profileAppList.filter(ele => ele.appId != "1");
    }
  }
  onDelete(event) {
    event.preventDefault();
    this.openDialog();
  }

  openDialog(): void {
    const dialogRef = this.dialogBox.open(DialogOverviewConfirmationComponent, {
      width: '500px',
      disableClose: true
    });
    this.dataToPass = {
      delUser:true,
      delData:this.userInfo
    };
    dialogRef.componentInstance.confirmData = this.dataToPass;
    dialogRef.afterClosed().subscribe(result => {
      if (result.event === 'confirmDelete') {
        this.sendOtp();
      }
    });
  }
  sendOtp(){
    this.showResend = false;
    this.apiService.delUserRquest(this.userprinciplename).subscribe({
      next: (data: any) => {
        this.otpView = true;
        this.showButton = false;
        this.submitShow = false;
        this.timeLeft = 90;
        this.dataEvent.emit({event:'deleteAccount'})
       this.startTimer();
      },
      error: err => { },
      complete: () => { }
    })
  }
  resend(){
    this.submitted = true;
    var attributeInvalid = false;
    if (this.otpModel.invalid) {
      attributeInvalid = true;
      return false;
    }
    this.apiService.delUserRecord(this.otpval).subscribe({
      next: (data: any) => {
       if(data){
        this.dataEvent.emit({event:'suceessDel'});
        this.userService.logout();
        window.location.href  = this.logOutUrl;
       }else {
        this.dataEvent.emit({event:'failureDel'});
       }
      },
      error: err => { 
        if(err.error.message != ''){
          this.dataEvent.emit({event:'error',message:err.error.error_code})
        }
      },
      complete: () => { }
    })
  }
  startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.showResend = true;
        this.submitShow = false;
        this.showButton = true;
        clearInterval(this.interval);
      }
    },1000)
  }
  getChanges(e) {
    if(e.checked){
      this.showButton = true;
      this.hideAll = true;
    } else {
      this.showButton = false;
      this.hideAll = false;
    }
  }
}
